import { createStore } from "effector";
import { LogoutDetailsDto } from "@state/logoutDetails/dto/response/logout.details.mode.dto";
import { logoutDetailsContextEvent } from "@state/logoutDetails/LogoutDetailsEvent";
import { requestGetLogoutDetails } from "@state/logoutDetails/LogoutDetailsEffects";

export const logoutDetailsStore = createStore<LogoutDetailsDto | null>(null)
  .on(logoutDetailsContextEvent, (_, payload) => {
    return payload ?? null;
  })
  .on(requestGetLogoutDetails.doneData, (_, payload) => {
    return payload.data ?? null;
  });
